export function streamPathFromCameraUrl(cameraUrl) {
  if (!cameraUrl) return "";
  try {
    const parsed = new URL(cameraUrl, "http://localhost");
    return decodeURIComponent(parsed.pathname.replace(/^\/+|\/+$/g, ""))
      .replace(/\/index\.m3u8$/i, "")
      .replace(/\.m3u8$/i, "");
  } catch {
    return String(cameraUrl).replace(/^\/+|\/+$/g, "");
  }
}

export function resolveHevcWebSocketUrl(cameraUrl) {
  const parsed = new URL(cameraUrl);
  const path = streamPathFromCameraUrl(cameraUrl);
  return `wss://${parsed.hostname}:8090/live?path=${encodeURIComponent(path)}`;
}
